import { ColorSwatch } from 'foundations-components/transitional/components/ColorSwatch';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Flex } from 'foundations-components/components/Flex';
import { ThemeProvider } from 'foundations-theming/components/ThemeProvider';
import { H7 } from 'foundations-components/transitional/components/H7';
import { jsx as _jsx } from "react/jsx-runtime";
export const CustomHighchartsTooltip = ({
  children
}) => /*#__PURE__*/_jsx(ThemeProvider, {
  children: /*#__PURE__*/_jsx(TFlex, {
    zIndex: "11",
    "data-test-id": "custom-highcharts-tooltip",
    children: /*#__PURE__*/_jsx(View, {
      minInlineSize: "150px",
      boxShadow: "100",
      children: children
    })
  })
});
export const TooltipHeader = ({
  children
}) => /*#__PURE__*/_jsx(View, {
  backgroundColor: "fill-accent-neutral-default",
  borderStartStartRadius: "100",
  borderStartEndRadius: "100",
  padding: "200",
  "data-test-id": "custom-highcharts-tooltip-header",
  children: /*#__PURE__*/_jsx(H7, {
    color: "text-core-on-fill-default",
    marginBlockEnd: "0",
    children: children
  })
});
export const TooltipFooter = ({
  children
}) => /*#__PURE__*/_jsx(View, {
  backgroundColor: "text-core-on-fill-default",
  padding: "200",
  children: /*#__PURE__*/_jsx(Text, {
    as: "small",
    typography: "detail-100",
    color: "text-core-default",
    children: children
  })
});
export const TooltipBodyListContainer = ({
  children
}) => /*#__PURE__*/_jsx(Flex, {
  justifyContent: "space-between",
  children: children
});
export const TooltipBodyLabel = ({
  children
}) => /*#__PURE__*/_jsx(Flex, {
  flexGrow: 1,
  children: /*#__PURE__*/_jsx(Text, {
    color: "text-core-default",
    typography: "heading-25",
    children: children
  })
});
export const TooltipBodyValue = ({
  children
}) => /*#__PURE__*/_jsx(Text, {
  color: "text-core-subtle",
  typography: "detail-100",
  paddingInlineStart: "100",
  children: children
});
export const TooltipBodySelected = ({
  children,
  selected
}) => /*#__PURE__*/_jsx(Text, {
  color: selected ? 'text-core-default' : 'text-primary-disabled',
  typography: "detail-100",
  children: children
});
export const TooltipBody = ({
  children
}) => /*#__PURE__*/_jsx(View, {
  backgroundColor: "text-core-on-fill-default",
  padding: "200",
  "data-test-id": "custom-highcharts-tooltip-body",
  children: children
});
export const TooltipSeriesSymbol = ({
  color
}) => /*#__PURE__*/_jsx(View, {
  marginInlineEnd: "100",
  children: /*#__PURE__*/_jsx(ColorSwatch, {
    color: color,
    size: 4
  })
});